import { render, staticRenderFns } from "./TheMyFavoritesProduct.vue?vue&type=template&id=73df34da&scoped=true"
import script from "./TheMyFavoritesProduct.vue?vue&type=script&lang=js"
export * from "./TheMyFavoritesProduct.vue?vue&type=script&lang=js"
import style0 from "./TheMyFavoritesProduct.vue?vue&type=style&index=0&id=73df34da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73df34da",
  null
  
)

export default component.exports